import './track-card.scss'
import { useDrag } from 'react-dnd'
import menuIcon from 'assets/icons/menu.svg'
import clsx from 'clsx'
import { useRef } from 'react'

const TrackCard = ({
  track,
  onTrackClick,
  onTrackDoubleClick,
  selectedTracks,
  index,
}) => {
  const clickConsumed = useRef(false)
  const isSelected = selectedTracks.find((item) => item.id === track.id)
  const { name, duration, fileConversionResult } = track

  const [{ opacity }, dragRef] = useDrag(
    () => ({
      type: 'track',
      item: {
        type: 'track',
        tracks: selectedTracks.map((item) => ({
          id: item.id,
          name: item.name,
        })),
      },
      collect: (monitor) => ({
        opacity: monitor.isDragging() ? 0.5 : 1,
      }),
    }),
    [selectedTracks],
  )

  const minutes = Math.floor(duration / 60 / 1000)
  const seconds = Math.floor((duration - minutes * 60 * 1000) / 1000)
  function handleTrackClick() {
    clickConsumed.current = false
  }

  function handleTrackMouseDown(evt) {
    if (!isSelected && fileConversionResult !== 'error') {
      clickConsumed.current = true
      onTrackClick(evt, track)
    }
  }

  function handleMouseUp(evt) {
    if (!clickConsumed.current && fileConversionResult !== 'error') {
      onTrackClick(evt, track)
    }
  }

  function handleTrackDoubleClick() {
    if (fileConversionResult !== 'error') {
      onTrackDoubleClick(track)
    }
  }

  return (
    <div
      className={clsx(
        'px-6 py-2 flex flex-row transition cursor-pointer',
        'rounded items-center border-0 w-full text-left',
        'hover:bg-white-light text-purple-dark ',
        'dark:hover:bg-gray-blue-light dark:text-white',
        {
          'bg-white dark:bg-gray-blue ': !isSelected,
          'outline outline-1 bg-salmon-light outline-salmon hover:bg-salmon-med-light dark:bg-blue-dark dark:outline-blue dark:hover:bg-blue':
            isSelected,
          'mt-[1px]': index === 0,
          'mt-2': index !== 0,
        },
      )}
      ref={dragRef}
      style={{ opacity }}
      onClick={handleTrackClick}
      onMouseDown={handleTrackMouseDown}
      onMouseUp={handleMouseUp}
      onDoubleClick={handleTrackDoubleClick}
    >
      <div className="flex-1 flex items-center">
        <div className="text-sm whitespace-nowrap flex-1">{name}</div>
        {fileConversionResult === 'converting' && (
          <div className="track-progress">
            <div className="bar">
              <div className="processing">
                <div>Processing File</div>
              </div>
            </div>
          </div>
        )}
      </div>
      {fileConversionResult === 'error' && (
        <div className="text-error text-center mx-5">
          <div className="text-sm">Error:</div>
          <div className="text-sm font-bold">Invalid File</div>
        </div>
      )}

      {duration > 0 && false && (
        <div className="text-lg mx-10">
          {minutes}:{seconds > 9 ? seconds : `0${seconds}`}
        </div>
      )}
    </div>
  )
}

export default TrackCard
